import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth'
import {
  fetchBrands,
  FetchBrandsActionTypes,
  fetchBrandsError,
  fetchBrandsSuccess,
} from '@store/brands'
import { selectFetchBrandsLink } from '@store/me'
import { networkRequest } from '@utils'

export function* handleFetchBrands(action: ReturnType<typeof fetchBrands>) {
  try {
    const authToken: string = yield select(selectAuthToken)
    const brandsLink: IHateoasLink = yield select(selectFetchBrandsLink)
    const context = action.payload?.context
    const url = context ? `${brandsLink.href}?context=${context}` : brandsLink.href
    const result = yield call(networkRequest, brandsLink.method, url, undefined, authToken)
    yield put(fetchBrandsSuccess(context ? { ...result, context } : result))
  } catch (error) {
    yield put(fetchBrandsError(error))
  }
}

export function* watchFetchBrandsRequest() {
  yield takeLatest(FetchBrandsActionTypes.FETCH_REQUEST, handleFetchBrands)
}
